"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = ["@media (max-width:978px){.top-spacing[_ngcontent-%COMP%]{padding-top:5%}.form-control-search[_ngcontent-%COMP%]{padding-right:165px}}@media (min-width:979px){.top-spacing[_ngcontent-%COMP%]{padding-top:2%}.form-control-search[_ngcontent-%COMP%]{width:90%}}.tab-content[_ngcontent-%COMP%]{margin-top:1.5em}.search-bar-background[_ngcontent-%COMP%]{background-color:#333}.vcenter[_ngcontent-%COMP%]{display:flex;align-items:center}.refine-option[_ngcontent-%COMP%]{box-shadow:inset 0 1px 5px #000}"];
exports.styles = styles;
//# sourceMappingURL=search.component.scss.shim.ngstyle.js.map